<template>
  <div class="container">
    <top num="2"></top>
    <img src="static/img/banner02.png" style="width: 100%" alt="" />
    <div class="main">
      <table></table>
      <p class="title">公司简介</p>
      <p class="desc">
        青铜科技是人工智能驱动的金融科技平台，为尚未享受到普惠金融服务的优质用户提供个性化的互联网消费金融产品，凭借自
      </p>
      <p class="desc">
        主研发的风控技术，以科技为驱动力，为用户提供便捷的产品体验。
      </p>
    </div>
    <div class="main" style="background: rgb(245, 247, 247)">
      <table></table>
      <p class="title">企业文化</p>
      <div class="flex">
        <div>
          <img src="static/img/qy01.png" alt="" />
          <div class="font">
            <p class="subtitle"><i>愿景</i></p>
            <p class="subdesc">成为拉美最满意的金融科技平台</p>
          </div>
        </div>
        <div>
          <img src="static/img/qy02.png" alt="" />
          <div class="font">
            <p class="subtitle"><i>使命</i></p>
            <p class="subdesc">
              通过科技创新为个人和家庭提供安全、快捷、普惠的金融业务
            </p>
          </div>
        </div>
        <div>
          <img src="static/img/qy03.png" alt="" />
          <div class="font">
            <p class="subtitle"><i>价值观</i></p>
            <p class="subdesc">踏实，简单，务实，高效</p>
          </div>
        </div>
        <div>
          <img src="static/img/qy04.png" alt="" />
          <div class="font">
            <p class="subtitle"><i>品牌口号</i></p>
            <p class="subdesc">始于安全，恒于科技</p>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <table></table>
      <p class="title">发展历程</p>
      <div class="tree">
        <div style="text-align: right">
          <div class="block" style="margin-top: 0.08rem">
            <div>
              <p>出海东南亚，落地越南</p>
              <img src="static/img/pic01.png" alt="" />
            </div>
            <p class="year">2019</p>
          </div>
          <div class="block" style="margin-top: 0.572rem">
            <div>
              <div>
                <p>3月落地墨西哥</p>
                <img src="static/img/pic03.png" alt="" />
              </div>
              <div style="margin-top: 0.78rem">
                <p>11月落地秘鲁</p>
                <img src="static/img/pic05.png" alt="" />
              </div>
            </div>
            <p class="year">2021</p>
          </div>
        </div>
        <div class="time">
          <div class="line"></div>
          <div class="circle"></div>
          <div class="circle" style="top: 1rem"></div>
          <div class="circle" style="top: 2rem"></div>
          <div class="circle" style="top: 3rem"></div>
          <div class="circle" style="top: 4rem"></div>
        </div>
        <div>
          <div class="block" style="margin-top: 0.88rem">
            <p class="year">2020</p>
            <div>
              <div>
                <p>5月布局拉美</p>
                <img src="static/img/pic02.png" alt="" />
              </div>
              <div style="margin-top: 0.78rem">
                <p>7月危地马拉职场</p>
                <img src="static/img/pic04.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main" style="background: rgb(245, 247, 247)">
      <table></table>
      <p class="title">一带一路</p>
      <p class="para">
        “一带一路”倡议，力求将我国过往几十年的高速发展积累的丰富经验和生产力带给世界，帮助同处在发展中阶段的“一带一路”国家少走弯路，除了在能源、交通和通讯等基础设施，也能在软件服务和信息全球化方面共享改革开放的成功经验和胜利果实。这将不仅能造福中国人民，加强中国和世界的联系，展现大国担当，更能造福沿线各国，实现跳跃式的阶段发展，一步享受到最好的科技和生产力，青铜科技向海外市场输出成熟的移动支付解决方案，把中国成熟的移动支付的能力输出给全世界。青铜科技借助一带一路的战略布局优势，在拉美国家已经拥有广泛的业务基础和规模。
      </p>
      <p class="para">
        网络基础设施和文化冲突上的差异，这些产品往往并不能特别好的满足其他区域的用户需求，特别是“一带一路”沿线国家，由于总体科技发展水平相对落后，加之语言和文化的差异，不但很难享受到欧美或中国创业者研发的优秀产品，同时又没有自己的科研能力为自己开发产品，导致当地人在寻找自己喜爱的内容进行消费时更是困难重重。
      </p>
      <p class="para">
        2018年，被认为中国移动互联网企业“金融科技出海元年”。随着移动出海产品从工具类向生活场景类延伸，开发者们需要更加关注不同地区的文化和习俗，只有深入了解一个地区的用户兴趣爱好、文化特征、行为习惯，才能更好地满足当地人需求。
      </p>
      <p class="para">
        为了能够真正做到深度的本地化，青铜在重点国家发展了一批内容运营人员，同时，在本地化运营以外，青铜一直致力于探索互联网最前沿的技术，包括人工智能、机器学习等，力求招募及培养出国内一流的工程技术团队，更好地为更多国家的用户提供世界领先的互联网金融产品。
      </p>
      <p class="para">
        从某种程度上来说，以青铜为代表的中国科技企业的“技术出海”、“商业模式出海”，是我国“一带一路”倡议全面贯彻的体现，也是中国开始向周边国家乃至全球越来越多地输出软实力的体现，印证着我国移动互联网的高速发展。一定会有越来越多的中国移动互联网企业，通过技术手段，将中国移动互联网生产力发展的优势走出“一带一路”，让沿线国家共享“中国快车”、“中国便车”，给沿线国家人民提供更多、更全方位的享受。
      </p>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import Bottom from "./bottom.vue";
import top from "./top.vue";
export default {
  components: { top, Bottom },
  name: "gsintro",
  data() {
    return {};
  },
};
</script>
<style scoped>
img {
  display: block;
  flex-shrink: 0;
}
.title {
  text-align: center;
  font-size: 0.208333rem;
  font-weight: bold;
  margin: 0.442708rem auto;
}
.desc {
  font-size: 0.104166rem;
  text-align: center;
  margin: 0.052083rem auto;
}
.main {
  padding-bottom: 0.598958rem;
}
.flex {
  display: flex;
  flex-wrap: wrap;
  width: 6rem;
  margin: 0 auto;
}
.flex > div {
  position: relative;
  width: 50%;
}
.flex img {
  width: 93%;
  margin: 0.1rem auto;
}
.font {
  position: absolute;
  color: white;
  top: 0.4rem;
  left: 0.3rem;
}
.subtitle {
  font-size: 0.208333rem;
  margin-bottom: 0.12rem;
}
.subdesc {
  font-size: 0.104167rem;
  width: 1.8rem;
}
.para {
  margin: 0.260417rem auto;
  font-size: 0.104167rem;
  width: 5.7rem;
  line-height: 0.2rem;
}

.time {
  width: 0.0625rem;
  position: relative;
  margin: 0 0.1rem;
}
.circle {
  width: 0.0625rem;
  height: 0.0625rem;
  border-radius: 50%;
  position: absolute;
  top: 0.2rem;
  left: 0;
  background: rgb(16, 158, 163);
}
.line {
  width: 0;
  border-left: 0.005208rem solid;
  border-right: 0.005208rem solid;
  height: 5rem;
  margin: 0 auto;
}
.tree {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 6rem;
  font-size: 0.125rem;
}
.block {
  display: flex;
  line-height: 0.3rem;
}
.block > div {
  margin: 0 0.286458rem;
}
.block img {
  width: 1.5625rem;
  margin-left: auto;
}
.year {
  color: rgb(16, 158, 163);
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/gsintro.vue